var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
var SvgChartEdit = function (props) { return (_jsx("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 18 18", width: "1em", height: "1em" }, props, { children: _jsx("path", { stroke: "currentColor", strokeMiterlimit: 10, strokeWidth: 1.25, d: "M11.063 5.438h3.624a.5.5 0 0 1 .5.5v.812m-8.249 8.438v-5.25H3.313a.5.5 0 0 0-.5.5v4.75zm0 0V3.313a.5.5 0 0 1 .5-.5h3.125a.5.5 0 0 1 .5.5v6.062m1.687 4.875 3.563-3.562a1.326 1.326 0 0 0-1.875-1.876l-3.563 3.563-.956.716a1.5 1.5 0 0 0-.597 1.084l-.134 1.759 1.758-.135a1.5 1.5 0 0 0 1.084-.596zm-1.875-1.875 1.875 1.875" }) }))); };
export default SvgChartEdit;
